import './loadHtmx';

require('./app');
require('./main');
require('./cart');

const handleFilter = function (e) {
    document.body.addEventListener('change', function (e) {
        if (e.target.matches('.js-sort')) {
            document.getElementById('js-sort-value').value = e.target.value;
            htmx.trigger("#js-product-filters", "change");
        }
    });
}

document.body.addEventListener('htmx:afterSettle', function(evt) {
    window.initLazyLoad();
    // handleFilter();
});

handleFilter();
